import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Box, Text } from '@chakra-ui/react'
import { FaTruck } from 'react-icons/fa'
import useStore from '../../../store'
import { colors } from '../../../utilities/colors'
import { Widget, WidgetHeader, WidgetBody } from '../../ui/Widget'
import OrderRow from './OrderRow'
import CarpoolOrderPage from './CarpoolOrderPage'
import CarpoolSupportButton from '../CarpoolSupportButton'
import useCarpoolOrdersSubscription from '../../../hooks/useCarpoolOrdersSubscription'
import useTransportationBasePath from '../../../hooks/useTransportationBasePath'

export default function CarpoolOrdersPage({ openOrdersInline = false }) {
  useCarpoolOrdersSubscription()
  const { t } = useTranslation()
  const navigate = useNavigate()
  const basePath = useTransportationBasePath()
  const { getDealerCarpoolOrders, dealerOrders, dealerOrdersFetching } = useStore()
  const [selectedOrderId, setSelectedOrderId] = useState(null)

  useEffect(() => {
    getDealerCarpoolOrders()
  }, [])

  if (openOrdersInline && selectedOrderId) {
    return (
      <CarpoolOrderPage
        orderId={selectedOrderId}
        onBack={() => setSelectedOrderId(null)}
      />
    )
  }

  const handleOrderClick = openOrdersInline
    ? (order) => setSelectedOrderId(String(order.attributes.id))
    : (order) => navigate(`${basePath}/orders/${order.attributes.id}`)

  return (
    <Widget>
      <WidgetHeader
        title={t('All Transport Orders')}
        showSpinner={dealerOrdersFetching}
        actionIcon={<CarpoolSupportButton />}
        overrideHeaderStyle={true}
      />
      <WidgetBody isVisible={!!dealerOrders}>
        {!dealerOrdersFetching && dealerOrders.length === 0 ? (
          <Box textAlign="center" p={8} color={colors.grey300}>
            <FaTruck size={32} style={{ margin: '0 auto 12px' }} />
            <Text fontSize="md">{t('No transport orders yet')}</Text>
            <Text fontSize="sm" mt={1} color={colors.grey}>
              {t('Place an order from a quote to get started')}
            </Text>
          </Box>
        ) : (
          dealerOrders.map((order) => (
            <OrderRow key={order.id} order={order} onClick={handleOrderClick} />
          ))
        )}
      </WidgetBody>
    </Widget>
  )
}
